import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PrecheckinStep1Repository } from '../repository/precheckin-step1.repository';

export class SendChangeHourUseCase implements UseCase<any, any> {
    constructor(private readonly repository: PrecheckinStep1Repository) {}

    execute(data: any): Observable<any> {
        return this.repository.sendChangeHour(data);
    }
}
